import { styled } from "@mui/material/styles";

/**
 * StyledWithdrawButton - Button with custom styles for withdrawal actions.
 */
export const StyledWithdrawButton = styled("button")(({ theme }) => ({
  height: "40px",
  paddingLeft: 50,
  paddingRight: 50,
  borderRadius: "21px",
  marginBottom: "10px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "normal",
  [theme.breakpoints.down(372)]: {
    width: "100%",
    marginLeft: 0,
  },
}));

/**
 * StyledDivider - Divider with custom margin.
 */
export const StyledDivider = styled("div")({
  marginBottom: 12,
});

/**
 * ClickableDiv - Div with pointer cursor for clickable elements.
 */
export const ClickableDiv = styled("div")({
  cursor: "pointer",
});
